/* human matter. · wspólne zachowania sekcji hm-* (bez bibliotek, ładowane z defer).
   1) .js-buy w dowolnej sekcji klika główny przycisk zakupu [data-hm-buy] (logika ilości i kasy żyje w hm-ef-buy.js);
      na stronie bez bloku zakupu przechodzi na adres przycisku nagłówka [data-hm-shop] (PDP #buy);
   2) przypisy [data-fn]: „Read more” / „Read less”;
   3) window.HM.inView(el, cb) — jednorazowe wejście w ekran (liczniki, paski osi);
   5) link do tej samej strony z kotwicą (np. /products/estrogen-fix#faq w nagłówku na PDP) przewija w miejscu, zamiast przeładować
      stronę (adres reklamy ma parametry, więc przeglądarka uznałaby go za inną stronę);
   4) odnośniki do przypisów (a[href^="#fn-"]): treść przypisu ze stopki w dymku przy odnośniku (Popover API), bez przewijania strony;
      bez Popover API albo bez przypisu w stopce zostaje zwykły skok do kotwicy. */
(function () {
  if (window.HM && window.HM.base) return;
  var HM = (window.HM = window.HM || {});
  HM.base = true;
  HM.RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  HM.inView = function (el, cb) {
    if (!('IntersectionObserver' in window) || HM.RM) { cb(el); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(el); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  };

  /* Pasek przewijany z kropkami (i opcjonalnie strzałkami, licznikiem): opinie u góry, kroki mechanizmu. */
  HM.strip = function (track, dots, prev, next, cnt, labels) {
    if (!track || track.dataset.hmStrip) return;
    track.dataset.hmStrip = '1';
    var its = [].slice.call(track.children), c = 0;
    if (dots) { dots.textContent = ''; its.forEach(function (s, i) { var d = document.createElement('i'); if (!i) d.className = 'on'; dots.appendChild(d); }); }
    function set(i) {
      c = i;
      if (dots) [].forEach.call(dots.children, function (d, k) { d.className = k === i ? 'on' : ''; });
      if (cnt && labels) cnt.textContent = labels[i] || '';
    }
    function go(i) {
      i = (i + its.length) % its.length;
      var pl = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      track.scrollTo({ left: its[i].offsetLeft - track.offsetLeft - pl, behavior: HM.RM ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(c - 1); });
    if (next) next.addEventListener('click', function () { go(c + 1); });
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) set(its.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      its.forEach(function (s) { o.observe(s); });
    }
  };

  var HAS_POP = typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('popover');
  var pop = null, popFrom = null, popY = 0;
  function i18n() {
    var el = document.querySelector('[data-hm-i18n]'), d = {};
    try { d = JSON.parse(el.textContent); } catch (e) {}
    return d;
  }
  function fnPop(link, note) {
    if (!pop) {
      var L = i18n();
      pop = document.createElement('div');
      pop.className = 'hm-fnpop'; pop.setAttribute('popover', 'auto'); pop.setAttribute('role', 'dialog');
      pop.setAttribute('aria-label', L.footnote || 'Footnote');
      pop.innerHTML = '<div class="hm-fnpop-t"></div><button type="button" class="hm-fnpop-x"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>';
      pop.querySelector('.hm-fnpop-x').setAttribute('aria-label', L.close || 'Close');
      document.body.appendChild(pop);
      pop.querySelector('.hm-fnpop-x').addEventListener('click', function () { pop.hidePopover(); });
      pop.addEventListener('toggle', function (e) {
        if (e.newState === 'closed' && popFrom) { try { popFrom.focus({ preventScroll: true }); } catch (x) {} popFrom = null; }
      });
      window.addEventListener('scroll', function () { if (popFrom && Math.abs(window.scrollY - popY) > 80) pop.hidePopover(); }, { passive: true });
    }
    if (pop.matches(':popover-open')) { popFrom = null; pop.hidePopover(); }
    pop.querySelector('.hm-fnpop-t').innerHTML = note.innerHTML;
    pop.style.left = '0px'; pop.style.top = '0px';
    pop.showPopover();
    popFrom = link; popY = window.scrollY;
    var r = link.getBoundingClientRect(), w = pop.offsetWidth, h = pop.offsetHeight, m = 12;
    var left = Math.min(Math.max(m, r.left + r.width / 2 - w / 2), window.innerWidth - w - m);
    var top = r.bottom + 8;
    if (top + h > window.innerHeight - m) top = Math.max(m, r.top - h - 8);
    pop.style.left = Math.round(left) + 'px'; pop.style.top = Math.round(top) + 'px';
    try { pop.querySelector('.hm-fnpop-x').focus({ preventScroll: true }); } catch (x) {}
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.js-buy');
    if (t) {
      var main = document.querySelector('[data-hm-buy]');
      if (main && main !== t) { e.preventDefault(); main.click(); return; }
      var shop = document.querySelector('[data-hm-shop]'); // strona bez bloku zakupu (home, How it works): przejście na PDP #buy
      if (!main && shop && t.tagName !== 'A') { e.preventDefault(); window.location.href = shop.href; }
      return;
    }
    var fr = e.target.closest('a[href^="#fn-"]');
    if (fr && !e.metaKey && !e.ctrlKey && !e.shiftKey && HAS_POP) {
      var note = document.getElementById(fr.getAttribute('href').slice(1));
      if (note && !note.contains(fr)) { e.preventDefault(); fnPop(fr, note); return; }
    }
    var sp = e.target.closest('a[href*="#"]');
    if (sp && !e.defaultPrevented && !sp.hasAttribute('data-rev') && !sp.matches('.js-buy') && !e.metaKey && !e.ctrlKey && !e.shiftKey &&
        sp.origin === location.origin && sp.pathname === location.pathname && sp.hash.length > 1) {
      var tg = document.getElementById(decodeURIComponent(sp.hash.slice(1)));
      if (tg) { e.preventDefault(); tg.scrollIntoView({ behavior: HM.RM ? 'auto' : 'smooth', block: 'start' }); try { history.pushState(null, '', sp.hash); } catch (x) {} return; }
    }
    var fb = e.target.closest('[data-fn] > button');
    if (fb) {
      var f = fb.parentElement, open = f.classList.toggle('open');
      f.classList.toggle('clamp', !open);
      fb.setAttribute('aria-expanded', open);
      fb.textContent = open ? fb.dataset.less : fb.dataset.more;
    }
  });
})();
